import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';
import Modal from 'react-bootstrap-modal';

import 'sass/modals/ModalRoomIsFull.scss';

import {t, dt} from 'l10n';
import {getPaymentUrl, getReturnPath} from '../../utils/url';


class ModalRoomIsFull extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        let {show, closeFn, returnPath} = this.props;

        if (!show) return null;

        return (
            <Modal className="modalRoomIsFull ui-kit-base" show={show} onHide={closeFn}>
                <Modal.Body>
                    <div className="close" onClick={closeFn}/>

                    <p className="text" dangerouslySetInnerHTML={{__html: t('This room is full. Only <span class="XXL">XXL</span> members are allowed to enter.')}}/>

                    <div className="buttons">
                        <Link to={getPaymentUrl(returnPath)} className="ui-button primary">{t('Become XXL')}</Link>
                    </div>

                </Modal.Body>
            </Modal>
        )
    }
}

export default ModalRoomIsFull;


// WEBPACK FOOTER //
// ./src/components/modals/ModalRoomIsFull.js